import React, { useState, useEffect } from 'react'
import bg from '../../images/vegabanner.jpg'
import { useMediaQuery } from 'react-responsive';
import ContactModal from './ContactModal';
import { setToggleTrue } from '../../redux/slice/changeState'
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-scroll';

const Banner = () => {
    const isTablet = useMediaQuery({ query: '(min-width: 992px) and (max-width: 1104px)' });
    const dispatch = useDispatch()
    const toggle = useSelector((state) => state.toggle);
    const [navSolid, setNavSolid] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 75) {
            setNavSolid(true);
        } else {
            setNavSolid(false);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <div className='banner position-relative'>
                <img src={bg} className='img-fluid w-100' alt="aspiration"></img>
                <div className='position-absolute banner-title'>
                    <h3>Welcome to <span className='ira'>VeeraSynergies</span>Pvt. Ltd</h3>
                </div>
                <div className='position-absolute banner-discption'>
                    {isTablet ?
                        <h1 className='text-uppercase m-50'>Your Partner in Infrastructure, Renewable Energy, Warehousing, and IT Consulting</h1>
                        :
                        <>
                            <h1 className='text-uppercase'>Your Partner in Infrastructure, Renewable Energy, Warehousing, and IT Consulting</h1>
                        </>
                    }

                    {/* <p className='m-50'>FREE Furnishings worth 8,88,888 INR</p>
                    <div>
                        <button className='visit-btn' onClick={() => dispatch(setToggleTrue())}>Book a Visit</button>
                        <button className='explore-btn'><a href='https://wa.api-whatsapp.in/ehbv4C' target="_blank" rel="noreferrer">Explore Floor Plans</a></button>
                    </div> */}
                    <div className='m-9'>
                        {/* <span className='text-white'>Ready-to-move in fully furnished luxury 2&3 BHK apartments in Kollur starting at <span className='special-bold'>₹1.20 Cr</span>.</span><br /> */}
                        <span className='text-white'>At VeeraSynergies, we believe in empowering businesses and communities with innovative, sustainable, and efficient solutions. Our expertise spans a wide range of industries, ensuring excellence and commitment in every project we undertake. From building world-class infrastructure to pioneering green energy initiatives, we are dedicated to delivering results that make a difference.</span>
                    </div>
                </div>
             
            </div>
          
        </>
    )
}

export default Banner
